import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {SharedModule} from "../../../ui-components/shared.module";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'vw-header-back-btn',
    imports: [
        SharedModule,
        TranslatePipe
    ],
    templateUrl: './header-back-btn.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-back-btn.component.scss'
})
export class HeaderBackBtnComponent {
  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  onBackClicked($event) {
    this.back.emit();
  }
}
